const trimTrailingSlash = (value: string) => value.replace(/\/+$/, "");

const isLocalhostUrl = (value: string) => {
  try {
    const url = new URL(value);
    return url.hostname === "localhost" || url.hostname === "127.0.0.1";
  } catch {
    return false;
  }
};

const isLocalBrowser = () =>
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

const inferBaseUrl = () => {
  const configured = import.meta.env.VITE_API_BASE_URL as string | undefined;
  if (configured && (isLocalBrowser() || !isLocalhostUrl(configured))) {
    return trimTrailingSlash(configured);
  }

  if (typeof window !== "undefined") {
    if (window.location.hostname === "doci.edgarhub.io") {
      return "https://gateway.edgarhub.io/doci";
    }

    if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
      return "http://localhost";
    }

    return window.location.origin;
  }

  return "http://localhost";
};

const baseUrl = inferBaseUrl();
const usesGatewayPrefixes = baseUrl.endsWith("/doci");
const devToken =
  import.meta.env.DEV || import.meta.env.MODE === "test"
    ? (import.meta.env.VITE_DEV_TOKEN as string | undefined)
    : undefined;

const env = {
  apiBaseUrl: baseUrl,
  ingestionApiUrl: trimTrailingSlash(
    (import.meta.env.VITE_INGESTION_API_URL as string | undefined) ??
      (usesGatewayPrefixes ? `${baseUrl}/ing` : `${baseUrl}:5001`)
  ),
  managementApiUrl: trimTrailingSlash(
    (import.meta.env.VITE_MANAGEMENT_API_URL as string | undefined) ??
      (usesGatewayPrefixes ? `${baseUrl}/mgt` : `${baseUrl}:5006`)
  ),
  crawlerApiUrl: trimTrailingSlash(
    (import.meta.env.VITE_CRAWLER_API_URL as string | undefined) ??
      (usesGatewayPrefixes ? `${baseUrl}/crw` : `${baseUrl}:5002`)
  ),
  llmApiUrl: trimTrailingSlash(
    (import.meta.env.VITE_LLM_API_URL as string | undefined) ??
      (usesGatewayPrefixes ? `${baseUrl}/llm` : `${baseUrl}:5005`)
  ),
  searchApiUrl: trimTrailingSlash(
    (import.meta.env.VITE_SEARCH_API_URL as string | undefined) ??
      (usesGatewayPrefixes ? `${baseUrl}/sch` : `${baseUrl}:5004`)
  ),
  grafanaUrl: trimTrailingSlash(
    (import.meta.env.VITE_GRAFANA_URL as string | undefined) ?? "http://localhost:3001"
  ),
  devToken,
} as const;

export default env;
